import React from "react";

import type { Maybe } from "@/types/utilities";
import type { ProcessedEntry } from "@/hooks/firestore/betting/useEntries";

import { isPast } from "date-fns";
import { Entry } from "@/features/entries/components/Entry";
import { EntrySkeleton } from "@/features/entries/components/pages/EntrySkeleton";
import {
  EmptySharePageMessage,
  ExpiredSharePageMessage,
} from "./SharePageMessage";

type SharedEntryCardProps = {
  entry: Maybe<ProcessedEntry>;
  loading: boolean;
  isCompact?: boolean;
  isPreview?: boolean;
};

export const SharedEntryCard = ({
  entry,
  loading,
  ...props
}: SharedEntryCardProps) => {
  if (loading) return <EntrySkeleton />;
  if (!entry) return <EmptySharePageMessage />;
  if (entry.expiresAtTs && isPast(entry.expiresAtTs.toDate()))
    return <ExpiredSharePageMessage />;

  return <Entry entry={entry} {...props} />;
};
